import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  InputAdornment,
  List,
  TextField,
} from "@mui/material";
import {
  noOptionsFound,
  search,
  select,
  selectState,
  stateLabel,
} from "./messages";
import { Input } from "./input/Input";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DialogBox from "./dialog/Dialog";
import SearchIcon from "@mui/icons-material/Search";
import Text from "./text/Text";
import { callAPIInterface } from "./constants";

const SelectStateDropdown = ({ formik, customClass }) => {
  const [isSelectStateModalOpen, setIsSelectStateModalOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [countries, setCountries] = useState([]);

  const { values, setFieldValue } = formik;

  const fetchCountries = async () => {
    try {
      const fetchedCountries = await callAPIInterface(
        "GET",
        `/country?limit=300`
      );
      setCountries(fetchedCountries?.data);
    } catch (error) {}
  };

  const states = useMemo(() => {
    return countries?.find((country) => country.short_name === values.country)
      ?.states;
  }, [values.country, countries]);

  const filteredStates = useMemo(() => {
    return states?.filter((state) =>
      state.name?.toLowerCase().includes(searchValue?.toLowerCase())
    );
  }, [searchValue, states]);

  const closeStateModal = () => {
    setIsSelectStateModalOpen(false);
  };

  useEffect(() => {
    fetchCountries();
  }, []);

  useEffect(() => {
    if (states?.length) {
      setFieldValue("statesAvailable", true);
    } else {
      setFieldValue("statesAvailable", false);
    }
    if (values.country) {
      setSearchValue("");
    }
  }, [states]);

  return (
    <>
      <Input
        customClass={`mt-16 cursor-pointer ${customClass}`}
        value={values?.state}
        fullWidth
        showLabel
        disabled={!values.country || !states}
        label={stateLabel}
        placeholder={select}
        onClick={() => setIsSelectStateModalOpen(true)}
        endAdornment={
          values.country &&
          states && (
            <InputAdornment position="end" sx={{ mr: 1 }}>
              <KeyboardArrowDownIcon
                style={{
                  width: 21,
                  height: 25,
                  color: "#848B9E",
                }}
              />
            </InputAdornment>
          )
        }
      />
      <DialogBox
        isOpenModal={isSelectStateModalOpen}
        setIsOpenModal={setIsSelectStateModalOpen}
        modalHeader={selectState}
        handleAction={closeStateModal}
        directionToOpen="up"
      >
        <Box className="country-dropdown">
          <TextField
            className="auto-complete-country"
            placeholder={search}
            name="state"
            value={searchValue}
            onChange={(e) => setSearchValue(e?.target?.value)}
            inputProps={{
              autoComplete: "off",
              autoFocus: true,
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment>
                  <SearchIcon sx={{ color: "#848B9E" }} />
                </InputAdornment>
              ),
            }}
          />
          <Card
            className="country-list-container"
            sx={{
              height: "100%",
            }}
          >
            <CardContent sx={{ p: "0 !important" }}>
              {filteredStates?.length > 0 ? (
                <List sx={{ p: "0 !important" }}>
                  {filteredStates?.map((state) => {
                    return (
                      <Box
                        key={state.id}
                        sx={{
                          p: "8px 0px",
                          height: "24px",
                          display: "flex",
                          width: "100%",
                          justifyContent: "space-between",
                        }}
                        className="cursor-pointer"
                        onClick={() => {
                          setSearchValue("");
                          setFieldValue(
                            "state",
                            state && typeof state === "object"
                              ? state.name
                              : state
                          );
                          closeStateModal();
                        }}
                      >
                        <Text
                          sx={{ color: "#101828" }}
                          font="semibold"
                          size={16}
                        >
                          {state?.name}
                        </Text>
                        <Text
                          sx={{ color: "#101828" }}
                          font="semibold"
                          size={16}
                        >
                          {state.stateCode}
                        </Text>
                      </Box>
                    );
                  })}
                </List>
              ) : (
                <Box
                  sx={{
                    p: "8px 0px",
                    height: "32px",
                    width: "100%",
                  }}
                >
                  <Text sx={{ color: "#101828" }} font="semibold" size={16}>
                    {noOptionsFound}
                  </Text>
                </Box>
              )}
            </CardContent>
          </Card>
        </Box>
      </DialogBox>
    </>
  );
};

export default SelectStateDropdown;
